import { methods } from '../services/api/ApiConstants';

const callTypes = {
    zoom: 'zoom',
    zoom_huichang: 'zoom_huichang',
    zoom_sdk_app: 'zoom_sdk_app',
    WebRTC: 'WebRTC',
};

const contextDisplayStatus = {
    CONTEXT_DISPLAY_REQ: 'context_display_req',
    CONTEXT_DISPLAY_ACK: 'context_display_ack',
    CONTEXT_HIDE_REQ: 'context_hide_req',
    CONTEXT_HIDE_ACK: 'context_hide_ack',
};

const sessionStatus = {
    CLOSED: 'closed',
    CREATED: 'created',
    FINISHED: 'finished',
    IN_PROGRESS: 'in_progress',
};

const sessionStorageKeys = {
    JOINED: 'remoteOralExamJoinedKey',
    COMPLETED: 'remoteOralExamCompletedKey',
    NOTE: 'remoteOralExamNoteKey',
};

const webRTCTestCallUrl = `${methods.VCC}?type=WebRTC&isTT=true`;

const zoomTestCallStatus = {
    NOT_REQUESTED: 'NOT_REQUESTED',
    CONFIRMED: 'CONFIRMED',
    FAILED: 'FAILED',
};

export default {
    callTypes,
    contextDisplayStatus,
    sessionStatus,
    sessionStorageKeys,
    webRTCTestCallUrl,
    zoomTestCallStatus,
};
